module.exports = __webpack_public_path__ + "static/on-the-bank-6266b683c83cc8133c9b9e46b3af72f4.jpg";